const clp = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 });
const numero = new Intl.NumberFormat('es-CL', { maximumFractionDigits: 3 });

export function formatoCLP(monto: number | string | null | undefined): string {
  if (monto === null || monto === undefined || monto === '') return '—';
  const n = typeof monto === 'string' ? Number(monto) : monto;
  return Number.isFinite(n) ? clp.format(n) : '—';
}

export function formatoNumero(n: number | string | null | undefined): string {
  if (n === null || n === undefined || n === '') return '—';
  const v = typeof n === 'string' ? Number(n) : n;
  return Number.isFinite(v) ? numero.format(v) : '—';
}

/** Fecha ISO (YYYY-MM-DD) a dd-mm-aaaa sin corrimiento de zona horaria. */
export function formatoFecha(iso: string | null | undefined): string {
  if (!iso) return '—';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  return m ? `${m[3]}-${m[2]}-${m[1]}` : iso;
}

export function formatoFechaHora(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('es-CL', { timeZone: 'America/Santiago', dateStyle: 'short', timeStyle: 'short' });
}

const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

export function formatoPeriodo(periodo: string | null | undefined): string {
  if (!periodo) return '—';
  const m = /^(\d{4})-(\d{2})$/.exec(periodo);
  return m ? `${MESES[Number(m[2]) - 1]} ${m[1]}` : periodo;
}
